import {
  FieldSection,
  FieldSectionTitle,
  FieldsRow,
  FormContainer,
  FormNumberField,
  FormRoleConfContext,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { useFormContext } from "react-hook-form"
import { formRoleConf } from "./Billing.formRoleConf"
import { BillingEnum, type BillingFormValues } from "./Billing.schema"

export function Billing() {
  const hasCipCode = !!useFormContext().getValues(BillingEnum.CIPCODE)
  const conf = useRoleConf(formRoleConf(hasCipCode))

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Facturation" />

        <FieldSection title="SIRET" subtitle="SIRET de de l’officine">
          <FormNumberField<BillingFormValues>
            label="N° SIRET"
            name={BillingEnum.SIRET}
          />
        </FieldSection>

        <FieldSection title="TVA" subtitle="TVA Intracommunautaire">
          <FormTextField<BillingFormValues>
            label="N° de TVA Intracommunautaire"
            name={BillingEnum.INTRACOMMUNITYVAT}
          />
        </FieldSection>

        <FieldSection title="Code CIP" subtitle="CIP de l’officine">
          <FormNumberField<BillingFormValues>
            format="2######"
            label="Code CIP"
            name={BillingEnum.CIPCODE}
            required
          />
        </FieldSection>

        <FieldSection
          title="ID Business Central"
          subtitle="ID servant à faire le lien avec Business Central"
        >
          <FormTextField
            name={BillingEnum.CENTRALBUSINESSID}
            disabled
            label="ID Business Central"
          />
        </FieldSection>

        <FieldSection title="Code finess">
          <FieldsRow>
            <FormNumberField<BillingFormValues>
              label="Code finess actuel"
              name={BillingEnum.ACTUALFINESSCODE}
              fullWidth
            />
            <FormNumberField<BillingFormValues>
              label="Ancien code finess"
              name={BillingEnum.LASTFINESSCODE}
              fullWidth
              disabled
            />
          </FieldsRow>
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
